import React, { useState, useEffect } from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { Card } from "antd";

export const ChannelPie = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const deliveredOrders = data?.filter((item) => item.status === "Entregado");

    const channels = Array?.from(
      new Set(deliveredOrders?.map((item) => item.channel))
    );

    const newChartData = channels?.map((channel) => {
      const channelOrders = deliveredOrders?.filter(
        (item) => item.channel === channel
      );

      const totalSales = channelOrders?.reduce(
        (acc, order) => acc + order.saleAmount,
        0
      );
      const totalUnits = channelOrders?.reduce(
        (acc, order) =>
          acc + order.products?.reduce((acc, item) => acc + item.quantity, 0),
        0
      );
      const orderCount = channelOrders.length;
      const averageTicket = totalUnits / orderCount;

      return {
        name: channel,
        totalSales,
        totalUnits,
        averageTicket,
        orderCount,
      };
    });

    setChartData(newChartData);
  }, [data]);

  const COLORS = [
    "#0a9396",
    "#244861",
    "#275F6F",
    "#2B767E",
    "#94d2bd",
    "#f8ad9d",
    "#ee9b00",
    "#ca6702",
    "#ae2012",
    "#e9d8a6",
    "#001219",
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <p>
            <strong>{payload[0].name}</strong>
          </p>
          <p>Total ventas: S/ {payload[0].value?.toFixed(2)}</p>
          <p>Total de órdenes: {payload[0].payload.orderCount}</p>
          <p>Total de productos: {payload[0].payload.totalUnits}</p>
          <p>Ticket promedio: {payload[0].payload.averageTicket?.toFixed(2)}</p>
        </div>
      );
    }
    return null;
  };

  const CustomLegend = ({ payload }) => {
    const total = payload?.reduce(
      (acc, item) => acc + item.payload.totalSales,
      0
    );
    return (
      <div>
        {payload.map((entry, index) => (
          <text key={`item-${index}`} style={{ color: entry.color }}>
            {entry.value}{" "}
            {((entry.payload.totalSales / total) * 100)?.toFixed(2)}%{" "}
          </text>
        ))}
      </div>
    );
  };

  return (
    chartData && chartData.length > 0 ? (
      <Card title="Canales">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="totalSales"
              label={({ percent }) =>
                percent > 0.03 ? `${(percent * 100)?.toFixed(2)}%` : ""
              }
            >
              {chartData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
  
            <Legend content={<CustomLegend />} />
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </Card>
    ) : (
      <Card title="Canales" className="h-[406px]"></Card>
    )
  );
  
};
